// EngagementChart.jsx
import React from 'react';
import { Bar } from 'react-chartjs-2';

const EngagementChart = ({ data }) => {
    return <Bar data={data} />;
};

export default EngagementChart;